import React from 'react'
import { Flex, Text, Illustration } from '@grammarly/design-system'

import { useTool } from '../../tool-context'
import { ToolOutputContentProps } from '../../types'
import { ToolLoading } from '../tool-loading'

export const GoTemplates: React.FC<ToolOutputContentProps> = () => {
  const { isLoading, submitButtonText, outputContent } = useTool()

  if (isLoading) {
    return <ToolLoading />
  }

  if (outputContent) {
    return outputContent
  }

  return (
    <Flex direction="column" justify="center" align="center" width="100%" height="100%" gap={6}>
      <Illustration type="empty-write" />
      <Text variant="text-small" as="p">
        Add your text and click {submitButtonText} to see results here
      </Text>
    </Flex>
  )
}

interface GoTemplatesOutputProps {
  output: string
}

export const GoTemplatesOutput: React.FC<GoTemplatesOutputProps> = ({ output }) => {
  return (
    <Text variant="text-medium" as="p">
      {output}
    </Text>
  )
}
